module.exports = __webpack_public_path__ + "static/img/Zac-Sarfati.389f87f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zac-Sarfati.jpg
// module id = L1VK
// module chunks = 0